import {forwardRef} from "react";

const BasicTextInput = forwardRef(function BasicTextInput(
    {
        className = "",
        name,
        value,
        onChange,
        onKeyDown,
        label,
        textArea = false,
        disabled,
        defaultValue,
        onBlur,
        type,
        autoComplete,
        required = false,
    },
    ref
) {
    const classes = `${className} w-full py-1.5 px-4 rounded text-black border border-gray-600 text-lg`;
    const styles = {
        backgroundColor: "#e8f0fe"
    }
    let inputElement;
    if (textArea) {
        console.assert(!type);
        inputElement =
            <textarea
                name={name}
                style={styles}
                value={value}
                onChange={onChange}
                className={classes}
                rows={4}
                disabled={disabled}
                defaultValue={defaultValue}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                autoComplete={autoComplete}
                required={required}
                ref={ref}
            />;
    } else {
        inputElement =
            <input
                type={type ?? "text"}
                style={styles}
                name={name}
                value={value}
                onChange={onChange}
                className={classes}
                disabled={disabled}
                defaultValue={defaultValue}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                autoComplete={autoComplete}
                required={required}
                ref={ref}
            />;
    }
    if (label) {
        return (
            <label>
                <div className="mb-0.5 font-bold text-lg">{label}</div>
                {inputElement}
            </label>
        )
    }
    return inputElement;
});

export default BasicTextInput;